import { Component, EventEmitter, OnInit } from "@angular/core";
import { ModalService } from "../../shared/services/modal.service";
import { ModalAdminAreaofinterestComponent } from "./modal-admin-areaofinterest/modal-admin-areaofinterest.component";
import { AdminService } from "../../shared/services/admin.service";
import { empty } from "../../functions";
import { Observable, ReplaySubject, Subject } from "rxjs";
import {
  alertMessages,
  AlertService,
} from "../../shared/services/alert.service";
import { catchError } from "rxjs/operators";

@Component({
  selector: "app-admin-fieldofinterest",
  templateUrl: "./admin-fieldofinterest.component.html",
  styleUrls: ["./admin-fieldofinterest.component.scss"],
  standalone: false,
})
export class AdminFieldofinterestComponent implements OnInit {
  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: "Name",
        name: "name",
        type: "text",
      },
      {
        header_name: "Name BE",
        name: "nameBe",
        type: "text",
      },
      {
        header_name: "Name EN",
        name: "nameEn",
        type: "text",
      },
      {
        header_name: "Name DE",
        name: "nameDe",
        type: "text",
      },
      {
        header_name: "Name FR",
        name: "nameFr",
        type: "text",
      },
      {
        header_name: "Name PT",
        name: "namePt",
        type: "text",
      },
      {
        header_name: "Tags",
        name: "tags",
        type: "array",
      },
    ],
    endpoint: "areaofinterest",
    data: <any>[],
    buttons: [
      {
        class: "btn btn-danger",
        event: "delete",
        text: "Delete",
      },
      {
        class: "btn btn-warning",
        event: "edit",
        text: "Edit",
      },
    ],
    class: "",
    reloadListener: new Subject(),
  };

  public view = {
    data: <any>[],
  };

  /**
   * Constructor
   *
   * @param modal
   * @param adminService
   * @param alertService
   */
  constructor(
    public modal: ModalService,
    public adminService: AdminService,
    private alertService: AlertService
  ) {}

  /**
   * Ng on init
   */
  ngOnInit(): void {}

  /**
   * Add a single area of interest
   */
  addAreaOfInterest() {
    const modalOptions = {
      backdrop: "static",
      size: "xl",
    };

    const data = {
      entity: {
        id: "",
        name: "",
        nameBe: "",
        nameEn: "",
        nameDe: "",
        nameFr: "",
        namePt: "",
        tags: [],
      },
    };

    this.modal
      .Modal(ModalAdminAreaofinterestComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.alertService.success(alertMessages.successDataSaved);

          this.configTable.reloadListener.next(true);
        }
      })
      .catch((error) => {});
  }

  /**
   * Update a single area of interest
   *
   * @param $data
   */
  updateAreaofinterest($data: any) {
    const modalOptions = {
      backdrop: "static",
      size: "xl",
    };

    const data = {
      entity: $data,
    };

    this.modal
      .Modal(ModalAdminAreaofinterestComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.alertService.success(alertMessages.successDataSaved);

          this.configTable.reloadListener.next(true);
        }
      })
      .catch((error) => {});
  }

  /**
   * Delete a single area of interest
   *
   * @param id
   */
  deleteAreaofinterest(id: string) {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          this.adminService
            .apiDeleteAreaofinterest(id)
            .pipe(
              catchError(
                this.adminService.handleError("apiDeleteAreaofinterest", false)
              )
            )
            .subscribe((result) => {
              if (result !== false) {
                this.alertService.success(alertMessages.successDataRemoved);

                // Reload data
                this.configTable.reloadListener.next(true);
              }
            });
        }
      })
      .catch((error) => {});
  }

  /**
   * Handle table button event
   *
   * @param $event
   */
  handleButtonEvent($event: any) {
    if (!empty($event["event"])) {
      switch ($event["event"]) {
        case "edit":
          this.updateAreaofinterest($event["data"]);
          break;

        case "delete":
          this.deleteAreaofinterest($event["data"]["id"]);
          break;
      }
    }
  }
}
